import React, { useRef, useEffect, useState } from 'react';
import moment from 'moment';
import {
  Table,
} from "tea-component";
import { scrollable, SortBy, sortable, injectable } from "tea-component/es/table/addons";
import { formatNum, formatPercentNum, getRatioText } from '@/pages/dashboard/utils/utils';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { MiniTableProps, MiniTableColumn } from './inderface';
import MetricAndUpDown from '../MetricAndUpDown';
import Loading from '../Loadings';
import NoData from '../NoData';
import './index.less'

// props的默认值
index.defaultProps = {
  className: '',
  tableOption: [],
  tableList: [],
  tableConfig: {},
  scrolLableVal: undefined,
  customDom: null,
  loading: true,
  height: 260,
};

/**
 * 根据国家名称 获取对应的国旗
 * @param {国家名称} name
 * @returns element
 */
function createImg(name, className = '') {
  let elem
  // 香港台湾 用 中国国旗
  name = ['hk', 'tw'].includes(name) ? 'cn' : name
  try {
    elem = <img className={className} src={getCountryFlag(name)} alt="flag" />
  } catch (error) {
    elem = <img className={className} src={getCountryFlag('undefined')} alt="flag" />
  }
  return elem
}

// render 配置
export function renderTableCols(colsConfig: MiniTableColumn[]) {
  /**
   * 数据处理
   * @param value 当前字段的值
   * @param record record
   * @param dataType 字段类型
   * @returns
   */
  const handleData = (value: any, record: { full_name: any; }, dataType: string) => {
    if (dataType && value) {
      return {
        // 保留整数
        integer: formatNum(value, false, true),
        // 保留两位小数
        twoDecimal: formatNum(value),
        // 百分比保留一位小数
        oneDecimalPercent: formatPercentNum(value, 1),
        // 百分比保留两位小数
        twoDecimalPercent: formatPercentNum(value, 2),
        // 月
        timeMonth: moment(value).format('YYYY-MM'),
        // 日、周
        time: moment(value).format('YYYY-MM-DD'),
        // 国家
        country: (
          <div className="db-table__info">
            {value === 'Others' ? '' : createImg(value, 'db-table__info-pic')}
            <span className="db-table__info-txt">{record?.full_name || value || '-'}</span>
          </div>
        ),
        region: record?.full_name || value || '-',
        zone: record?.full_name || value || '-'
      }[dataType]
    } else if (value) {
      return value
    }
    return '-'
  }

  return colsConfig?.map(({ render, dataType, ratioField, ...other }) => {
    return {
      ...other,
      render:
        render ||
        ((record) => {
          let textValue = handleData(record[other.key], record, dataType)
          // 双列
          if (ratioField) {
            const { text, status } = getRatioText(record?.[ratioField], false)
            textValue = (
              <MetricAndUpDown
                metric={textValue}
                updown={{ data: text, status }}
              />
            )
          }
          return textValue
        }),
    }
  })
}

/**
 *  卡片区域可切换的小表格
 */
export default function index(props: MiniTableProps) {
  const {
    className,
    tableOption,
    tableList,
    tableConfig,
    scrolLableVal,
    customDom,
    height = 302,
    loading,
    recordKey = "id",
    onScroll,
    onScrollToBottom
  } = props;
  const tableRef = useRef(null)

  // isSortable开启排序,disableChangeSort=true默认禁用切换
  const { isSortable = false, columns, defaultValue, disableChangeSort = true } = tableConfig || {}
  const setSortableConfig = isSortable ? (tableConfig?.setSortableConfig || ((sorts, setSorts) => {
    return {
      columns: columns,
      value: sortValue,
      onChange: value => setSortValue(value),
    }
  })) : null
  // 设置排序值
  const [sortValue, setSortValue] = useState<SortBy[]>(defaultValue || [])
  const scrollFunc = (e) => {
    e.stopPropagation()
    const target = e.target

    // 滚动到底部
    if ((Math.ceil(target.scrollTop + target.clientHeight)) === target.scrollHeight) {
      onScrollToBottom?.(target)
    } else {
      onScroll?.(target)
    }
  }

  useEffect(() => {
    if (!tableRef.current) return
    const target = (tableRef.current as any).getElementsByClassName?.('tea-table__body')[0]

    // 防止重复绑定
    target?.removeEventListener('scroll', scrollFunc)
    target?.addEventListener?.('scroll', scrollFunc)

    return () => {
      target?.removeEventListener('scroll', scrollFunc)
    }
  })

  useEffect(() => {
    // 移除所有自带的 title 属性，不展示浏览器默认浮窗提示文本
    const oTargets = document.querySelectorAll('.tea-table__body .tea-text-overflow')
    oTargets?.forEach((element) => {
      element.setAttribute('title', '')
    })
  })

  return (
    <>
      {
        loading ? (<div style={{ height: height }}><Loading /></div>) :
          Object.prototype.toString.call(tableList) === '[object Array]' && tableList.length > 0
            ? <Table
              style={{ height: height }}
              ref={tableRef}
              className={`db-table ${className}`}
              recordKey={(record, index) => ('' + (record[recordKey] ? record[recordKey] + index : index))}
              columns={tableOption as any}
              records={isSortable && setSortableConfig ? [...tableList].sort(sortable.comparer(sortValue)) : tableList}
              addons={[
                scrollable(scrolLableVal || {
                  minHeight: +height - 302 + 260,
                  maxHeight: +height - 302 + 260,
                }),
                isSortable && setSortableConfig && !disableChangeSort && sortable(setSortableConfig(sortValue, setSortValue)) || '',
                injectable({
                  cell: (props, context) => ({
                    className: context.column.key,
                  })
                })
              ]}
            />
            : (<div style={{ height: height, position: 'relative' }}><NoData /></div>)
      }
      {customDom}
    </>
  );
};
